import * as styles from "./FundRatings.css";
import type { FundOverviewSection } from "./types";

export default function FundRatings({
	ratings,
	placement,
}: { ratings: FundOverviewSection["ratings"] } & styles.Variants) {
	const { note, ...__ratings } = ratings;
	const fundRatings = Object.values(__ratings).filter(
		(value) => value && value.length > 0,
	);
	if (fundRatings.length === 0) {
		return null;
	}
	return (
		<div>
			<div className={styles.ratingImagesWrap}>
				<div className={styles.ratingImages({ placement })}>
					{fundRatings.map((fr) => (
						<img
							src={`${process.env.SRP_ROOT}${fr}`}
							key={fr}
							alt=""
							className={styles.ratingImage({ placement })}
						/>
					))}
				</div>
			</div>
			{note && <div className={styles.ratingsNote({ placement })}>{note}</div>}
		</div>
	);
}
